import { Controller, useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import {
  FlatActionList,
  Text,
  Stack,
  Divider,
  Label,
  TextField,
} from "@towersystems/roam-common-native";
import { textButtonProps } from "../../constants";
import React from "react";
import { SupplierIdToName } from "../../../../../../components";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface SupplierFieldsetProps {
  onSelectSupplierPress?: () => void;
}

export const SupplierFieldset = ({
  onSelectSupplierPress,
}: SupplierFieldsetProps) => {
  const { t } = useTranslation("product");

  const { watch, setValue, control } = useFormContext<ProductFormValues>();

  const watchedSupplierId = watch("supplierId");
  const watchedGlobalDisable = watch("globalDisable");

  React.useEffect(() => {
    if (!watchedSupplierId) {
      setValue("supplierStockCode", "", {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [setValue, watchedSupplierId]);

  const textProps = {
    ...textButtonProps,
    ...(watchedGlobalDisable ? { color: "subdued" } : {}),
  };

  return (
    <View>
      <Stack vertical>
        <FlatActionList
          items={[
            {
              key: "supplierId",
              title: t("form.supplier_id.label"),
              subTitle: t("form.supplier_id.description"),
              disabled: watchedGlobalDisable,
              onPress: onSelectSupplierPress,
              componentRight: () =>
                watchedSupplierId ? (
                  <SupplierIdToName
                    supplierId={watchedSupplierId}
                    {...textProps}
                  />
                ) : (
                  <Text {...textProps}>
                    {t("form.supplier_id.placeholder")}
                  </Text>
                ),
            },
          ]}
        />
      </Stack>
      {watchedSupplierId ? (
        <>
          <Divider />
          <View>
            <Label required label={t("form.supplier_stock_code.label")}></Label>
            <Controller
              name="supplierStockCode"
              control={control}
              disabled={watchedGlobalDisable}
              render={({
                field: { onChange, value, disabled },
                fieldState: { error },
              }) => (
                <TextField
                  value={value ?? ""}
                  readonly={!watchedSupplierId || disabled}
                  onChangeText={onChange}
                  validationMessage={error ? error.message : undefined}
                  placeholder={t("form.supplier_stock_code.placeholder")}
                />
              )}
            />
          </View>
        </>
      ) : null}
    </View>
  );
};
